// Contractor status enum matching API
export enum EntityStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

// Contractor from API
export interface Contractor {
  _id: string;
  name: string;
  companyName: string;
  email: string;
  phone: string;
  profileLogo?: string;
  rating: number;
  websiteUrl?: string;
  description?: string;
  insuranceDocument?: string;
  licenseDocument?: string;
  status: EntityStatus;
  createdAt: string;
  updatedAt: string;
}

// Input for creating a contractor
export interface CreateContractorInput {
  name: string;
  companyName: string;
  email: string;
  phone: string;
  profileLogo?: string;
  rating?: number;
  websiteUrl?: string;
  description?: string;
  insuranceDocument?: string;
  licenseDocument?: string;
  status?: EntityStatus;
}

// Input for updating a contractor (allows null to clear optional fields)
export type UpdateContractorInput = Partial<
  Omit<
    CreateContractorInput,
    'profileLogo' | 'websiteUrl' | 'description' | 'insuranceDocument' | 'licenseDocument'
  >
> & {
  profileLogo?: string | null;
  websiteUrl?: string | null;
  description?: string | null;
  insuranceDocument?: string | null;
  licenseDocument?: string | null;
};

// Query params for listing contractors
export interface ContractorQueryParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  status?: EntityStatus;
  minRating?: number;
  search?: string;
}

// Paginated response from API
export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}
